"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraformingUnits = void 0;
var TerraformingUnits;
(function (TerraformingUnits) {
    TerraformingUnits.EMPTY = {
        get temperature() {
            return 0;
        },
        get oxygen() {
            return 0;
        },
        get ocean() {
            return 0;
        },
        get venus() {
            return 0;
        },
        get tr() {
            return 0;
        },
    };
    function of(partialUnits) {
        return {
            temperature: partialUnits.temperature === undefined ? 0 : partialUnits.temperature,
            oxygen: partialUnits.oxygen === undefined ? 0 : partialUnits.oxygen,
            ocean: partialUnits.ocean === undefined ? 0 : partialUnits.ocean,
            venus: partialUnits.venus === undefined ? 0 : partialUnits.venus,
            tr: partialUnits.tr === undefined ? 0 : partialUnits.tr,
        };
    }
    TerraformingUnits.of = of;
})(TerraformingUnits = exports.TerraformingUnits || (exports.TerraformingUnits = {}));
//# sourceMappingURL=TerraformingUnits.js.map